export const calculateRecommendedMaxChars = ({ cps, speed, duration }) => {
  if (!cps || cps <= 0 || duration <= 0) return null;

  return Math.ceil(cps * speed * duration);
};

export const isExceedRecommendedChars = (currentChars, maxRecommended) => {
  if (maxRecommended === null) return false;
  return currentChars > maxRecommended;
};
